import AbstractScene from './AbstractScene.js';
import eventsCenter from '../sydo/prefab/EventCenter.js'
import { Colors } from '../consts/Colors.js';
import Button from '../prefabs/Button.js';
import { tags } from '../consts/Tags.js';

export default class UI extends AbstractScene {

    constructor() {
        super({
            key: "UI"
        })
    }
    init(data) {
    }

    preload() {
        this._preload();

        eventsCenter.on('startgame', () => {this.startPopUp()})
        eventsCenter.on('endgame', () => {this.time.addEvent({delay: 3000, callback: () => {this.endPopUp()}})})
        eventsCenter.on('showtitle', () => {this.showTitle()})
        eventsCenter.on('hidetitle', () => {this.hideTitle()})

        this.titleGroup = this.add.group()

    }

    create(){
        this.addTitle()
        this.hideTitle()
    }

    pauseScene(){
        // Pause la scene
        var sceneRunning = this.game.data.sceneRunning
        this.scene.pause(sceneRunning);
    }

    restartScene(){
        // Restart la scene
        var sceneRunning = this.game.data.sceneRunning
        this.scene.wake(sceneRunning);
    }

    startPopUp(){
        this.pauseScene()

        this.blur = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.DarkBlue).setOrigin(0)

        this.popup = this.add.container(this.width/2, this.height/2, [])

        const back = this.add.sprite(0, 0, "popup")
        this.popup.add(back)

        const text = this.add.text(0, 0, "Placez chaque photographie\ndans la bonne case\ndu bilan comptable.", {
            font: "30px " + Fonts.Masilia,
            color: Colors.Text.White,
            align: "center"
        }).setOrigin(0.5)
        this.popup.add(text)

        const button = new Button(this, 0, back.height/2 - 50)
        this.popup.add(button)
        button.setClickFunction(()=> {this.hidePopUp()})

        this.blur.setAlpha(0)
        this.tweens.add({
            targets: [this.blur],
            duration: 200,
            alpha: 0.5
        })

        this.popup.setAlpha(0)
        this.tweens.add({
            targets: [this.popup],
            duration: 200,
            alpha: 1
        })
    }

    endPopUp(){
        this.pauseScene()

        this.blur = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.DarkBlue).setOrigin(0)

        this.popup = this.add.container(this.width/2, this.height/2, [])

        const back = this.add.sprite(0, 0, "popup")
        this.popup.add(back)

        const text0 = this.add.text(0, 0, "Félicitations !", {
            font: "60px " + Fonts.Masilia,
            color: Colors.Text.Orange,
            align: "center"
        }).setOrigin(0.5, 0)
        this.popup.add(text0)

        const text1 = this.add.text(0, text0.y + text0.height + 5, "Ce jeu est terminé.", {
            font: "25px " + Fonts.Masilia,
            color: Colors.Text.Orange,
            align: "center"
        }).setOrigin(0.5, 0)
        this.popup.add(text1)

        const text2 = this.add.rexTagText(0, text1.y + text1.height + 10, "\nLe bilan comptable n'a plus aucun secret pour vous !\nDécouvrez la vidéo\n<class=\"lien\">« Simple comme Compta : le compte de résultat »</class>.", {
            fontSize: "26px",
            fontFamily: Fonts.Masilia,
            color: Colors.Text.White,
            align: "center",
            tags:tags
        }).setOrigin(0.5, 0)
        this.popup.add(text2)

        text2.setInteractive({useHandCursor: true})
        text2.on('areaup', (key, pointer, localX, localY) => {
            if(key == "lien"){
                window.open("https://youtu.be/DhuzWup7U3w",'_blank');
            }
        })

        var Y = text2.y + text2.height

        text0.y -= Y/2
        text1.y -= Y/2
        text2.y -= Y/2

        const button = new Button(this, 0, back.height/2 - 50)
        this.popup.add(button)
        button.setClickFunction(()=> {this.hidePopUp()})

        this.blur.setAlpha(0)
        this.tweens.add({
            targets: [this.blur],
            duration: 200,
            alpha: 0.5
        })

        this.popup.setAlpha(0)
        this.tweens.add({
            targets: [this.popup],
            duration: 200,
            alpha: 1
        })
    }

    hidePopUp(){
        this.tweens.add({
            targets: [this.popup],
            duration: 200,
            alpha: 0,
            onComplete: () => {
                this.blur.destroy()
                this.popup.destroy()
                this.restartScene()
            }
        })
    }

    addTitle(){

        var logoABC = this.add.sprite(62, 90, 'logoMQDE').setOrigin(0, 0.5)
        logoABC.setScale(0.8)
        this.titleGroup.add(logoABC)
        logoABC.setInteractive({useHandCursor:true})
        logoABC.on('pointerup', () => {
            window.open("https://www.mesquestionsdentrepreneur.fr/",'_blank');
        })

        // Ajout titre
        var X = logoABC.x + logoABC.width + 15
        var Y = logoABC.y + logoABC.height /2
        console.log(Y)
        var title = this.add.rexTagText(X, 125, "Trésorerie nette, Fonds de Roulement et Besoin en Fonds de Roulement", {
            fontSize: "44px",
            fontFamily: "MassiliaBold",
            fontStyle: 'bold',
            backgroundColor: "transparent",
            color: Colors.Text.Purple
        })
        title.setOrigin(0, 1)
        this.titleGroup.add(title)

        var Xline = logoABC.x - logoABC.width /2
        var line = this.add.rectangle(Xline, Y + 10, this.width - Xline*2, 5, Colors.Elmt.Purple)
        line.setOrigin(0)
        this.titleGroup.add(line)

    }

    showTitle(){
        this.titleGroup.getChildren().forEach(elmt => {
            elmt.setAlpha(1)
        })
    }

    hideTitle(){
        this.titleGroup.getChildren().forEach(elmt => {
            elmt.setAlpha(0)
        })
    }
}